import { render, staticRenderFns } from "./DocumentsPanel.vue?vue&type=template&id=dd2889b4&scoped=true"
import script from "./DocumentsPanel.vue?vue&type=script&lang=js"
export * from "./DocumentsPanel.vue?vue&type=script&lang=js"
import style0 from "./DocumentsPanel.vue?vue&type=style&index=0&id=dd2889b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd2889b4",
  null
  
)

export default component.exports